/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

export const FlagsPermissionShipmentRates = {
    permission_shipment_rates_my_enable: new FcsFlag.Flag(false),
    permission_shipment_rates_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionShipmentRates() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureShipmentRates", FlagsPermissionShipmentRates);
}
